// src/confluence/embed/types.ts
var ConfluenceEmbedAriResourceOwner = "confluence", ConfluenceEmbedAriResourceType = "embed";

export {
  ConfluenceEmbedAriResourceOwner,
  ConfluenceEmbedAriResourceType
};
